import { render } from "./TPAAdd.vue?vue&type=template&id=75e71f30&scoped=true"
import script from "./TPAAdd.vue?vue&type=script&lang=js"
export * from "./TPAAdd.vue?vue&type=script&lang=js"

import "./TPAAdd.vue?vue&type=style&index=0&id=75e71f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e71f30"]])

export default __exports__